module.exports = __webpack_public_path__ + "static/media/SIP-T46S_large.3ad0b2b8.png";